
import template from './add_product_dialog.html';

var AddProductViewModel = function(page)
{
	var self = this;
	self.page = page;

	this.site_id = ko.observable();
	this.site_name = ko.observable();
	this.site_ip = ko.observable();
	this.site_location = ko.observable();
}

var AddProductClass = function(bindings)
{
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new AddProductViewModel(this);
	this.name = 'Add Product';

	this.init = function() {

	};

	this.add_product = function() {
		$.postJSON('/product/upsert', {  product_code:$('#txtProductCode').val(),
            name: $('#txtProductName').val(),
            description: $('#txtDescription').val()}, function(res) {
			self.close(false);
		});
	};

	this.onClose = function() { 
	};

	this.btnclose = function() {
		self.close(false);
	};


}

//Register the dialog
export default {
	name: 'AddProduct',
	dialog_class: AddProductClass,
	template: template
};

